/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_No_Cargos_To_AuditInputs */

const en_audit_no_cargos_to_audit = /** @type {(inputs: Audit_No_Cargos_To_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cargos to audit`)
};

const es_audit_no_cargos_to_audit = /** @type {(inputs: Audit_No_Cargos_To_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cargas para auditar`)
};

/**
* | output |
* | --- |
* | "No cargos to audit" |
*
* @param {Audit_No_Cargos_To_AuditInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_no_cargos_to_audit = /** @type {((inputs?: Audit_No_Cargos_To_AuditInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_No_Cargos_To_AuditInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_no_cargos_to_audit(inputs)
	return es_audit_no_cargos_to_audit(inputs)
});